import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;

  .header {
    h1 {
      font-family: Sora, sans-serif;
      font-size: 28px;
      font-weight: 600;
      color: #101d40;
    }

    & > p {
      font-family: Sora, sans-serif;
      font-weight: 400;
      padding-top: 5px;
      color: #9e9e9e;
      font-size: 16px;

      span {
        font-weight: 600;
      }
    }
  }
`;
